export default __webpack_public_path__ + "static/media/breaker3.32a60ee9.png";